import './App.css';
import {Row, Col, Form, Button, Divider, InputNumber, Typography, Select} from 'antd';
import {useState} from "react";

const App = () => {
    const [form] = Form.useForm();
    const [result, setResult] = useState(null);
    const [claimedAmountText, setClaimedAmountText] = useState(null);
    const [additionalCostText, setAdditionalCostText] = useState(null);

    const formatCurrency = (num) => {
        // 处理非数字情况
        if (isNaN(num)) return "无效金额";

        // 最大支持万亿级别
        const units = ["", "万", "亿", "万亿"];

        // 将数字转为字符串并处理负号
        let str = Math.abs(num).toString();
        let [integerPart, decimalPart] = str.split('.');

        // 处理整数部分
        let integerStr = "";
        let unitIndex = 0;

        while (integerPart.length  > 0) {
            const segment = integerPart.slice(-4);  // 每次处理4位
            integerPart = integerPart.slice(0,  -4);

            let segmentStr = parseInt(segment).toString();
            if (segmentStr !== "0") {
                segmentStr += units[unitIndex];
                integerStr = segmentStr + integerStr;
            }

            unitIndex++;
        }

        // 合并整数和小数部分
        let result = (num < 0 ? "-" : "") +
            (integerStr || "0") +
            (decimalPart ? "." + decimalPart : "") +
            "元";

        // 处理无整数部分的情况（纯小数）
        if (integerStr === "" && decimalPart) {
            result = (num < 0 ? "-" : "") + "0." + decimalPart + "元";
        }

        return result;

    }

    const getBaseFee = (fee) => {
        let feeTemp = fee;
        let totalFee = 0;
        if (feeTemp > 100000000) {
            totalFee += (feeTemp - 100000000) * 0.0015;
            feeTemp = 100000000;
        }
        if (feeTemp > 50000000) {
            totalFee += (feeTemp - 50000000) * 0.0026;
            feeTemp = 50000000;
        }
        if (feeTemp > 30000000) {
            totalFee += (feeTemp - 30000000) * 0.004;
            feeTemp = 30000000;
        }
        if (feeTemp > 10000000) {
            totalFee += (feeTemp - 10000000) * 0.006;
            feeTemp = 10000000;
        }
        if (feeTemp > 5000000) {
            totalFee += (feeTemp - 5000000) * 0.008;
            feeTemp = 5000000;
        }
        if (feeTemp > 1000000) {
            totalFee += (feeTemp - 1000000) * 0.01;
            feeTemp = 1000000;
        }
        totalFee += feeTemp * 0.02;

        return totalFee;
    };

    const onClaimedAmountChange = value => {
        setClaimedAmountText(formatCurrency(Number(value)));
    }

    const onAdditionalCostChange = value => {
        setAdditionalCostText(formatCurrency(Number(value)));
    }

    const onFinish = values => {

        const {claimedAmount, difficulty, additionalCost} = values;
        const baseFee = getBaseFee(claimedAmount);
        const difficultyFee = Number(baseFee) * Number(difficulty) / 100;
        const totalAmount = getBaseFee(claimedAmount) + difficultyFee + Number(additionalCost);
        setResult({
            baseFee: (Math.ceil(baseFee * 100) / 100).toFixed(2),
            difficultyFee: (Math.ceil(difficultyFee * 100) / 100).toFixed(2),
            totalAmount: (Math.ceil(totalAmount * 100) / 100).toFixed(2)
        });
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const handeReset = () => {
        form.resetFields();
        setClaimedAmountText(null);
        setResult(null);
    }

    return (
        <div className="App">
            <Row type="flex" justify='center' align="middle">
                <Col span={24} align="middle">
                    <Typography.Title level={2} style={{color:'rgb(217, 217, 217)'}}>建设工程造价鉴定收费计算器</Typography.Title>
                    <Typography.Title level={3} style={{color:'rgb(217, 217, 217)', margin: '0'}}>（上海费率）</Typography.Title>
                    <Divider style={{borderColor: 'rgb(217, 217, 217)'}}/>

                </Col>
                <Col span={24}>
                    <Row type="flex" justify='center' align="middle" style={{marginBottom: '30px'}}>
                        <Col>
                            <Select
                                defaultValue="shanghai"
                                style={{ width: 300, backgroundColor: 'rgb(217, 217, 217)', borderRadius: '6px' }}
                                disabled
                                options={[{ value: 'shanghai', label: '上海' }]}
                            />
                        </Col>
                    </Row>
                    <Row type="flex" justify='center' align="middle">
                        <Col>
                            <Form
                                form={form}
                                name="basic"
                                style={{ maxWidth: 600 }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                <Form.Item
                                    label={<label style={{ color: "rgb(217, 217, 217)" }}>标的金额</label>}
                                    name="claimedAmount"
                                    rules={[{ required: true, message: '请输入标的金额！' }]}
                                >
                                    <InputNumber style={{width: '100%'}} onChange={e => onClaimedAmountChange(e)} />
                                </Form.Item>

                                {!!claimedAmountText &&
                                    <Form.Item
                                        label={null}
                                        colon={false}
                                    >
                                        <label style={{ color: "rgb(217, 217, 217)" }}>{claimedAmountText}</label>
                                    </Form.Item>
                                }
                                <Form.Item
                                    label={<label style={{ color: "rgb(217, 217, 217)" }}>难度系数</label>}
                                    name="difficulty"
                                    rules={[{ required: true, message: '请输入难度系数！' }]}
                                >
                                    <InputNumber
                                        min={0}
                                        max={100}
                                        addonAfter={'%'}
                                        parser={value => (value === null || value === void 0 ? void 0 : value.replace('%', ''))}
                                        style={{width: '100%'}}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label={<label style={{ color: "rgb(217, 217, 217)" }}>其他费用核定</label>}
                                    name="additionalCost"
                                    rules={[{ required: true, message: '请输入其他费用核定！' }]}
                                >
                                    <InputNumber style={{width: '100%'}} onChange={e => onAdditionalCostChange(e)}/>
                                </Form.Item>

                                {!!additionalCostText &&
                                    <Form.Item
                                        label={null}
                                        colon={false}
                                    >
                                        <label style={{ color: "rgb(217, 217, 217)" }}>{additionalCostText}</label>
                                    </Form.Item>
                                }

                                <Row>
                                    <Col span={12}>
                                        {result ?
                                            <Form.Item label={null}>
                                                <Button type="primary" danger onClick={handeReset}>
                                                    重置
                                                </Button>
                                            </Form.Item> : null}
                                    </Col>
                                    <Col span={12} align="end">
                                        <Form.Item label={null}>
                                            <Button type="primary" htmlType="submit">
                                                计算
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                        <Col span={24} align="middle">
                            <Divider style={{borderColor: 'rgb(217, 217, 217)'}}>{result ? <span style={{color: 'rgb(217, 217, 217)'}}>结果</span> : null}</Divider>
                        </Col>
                        <Col xl={12} lg={24} sm={24} xs={24} align="middle">
                            {!result ? null :
                                <div>
                                    <p style={{ color: "rgb(217, 217, 217)" }}>基本费： {`${result.baseFee} => ${formatCurrency(Number(result.baseFee))}`}</p>
                                    <p style={{ color: "rgb(217, 217, 217)"}}>难度费： {`${result.difficultyFee} => ${formatCurrency(Number(result.difficultyFee))}`}</p>
                                    <p style={{ color: "rgb(217, 217, 217)" }}>总费用： {`${result.totalAmount} => ${formatCurrency(Number(result.totalAmount))}`}</p>
                                </div>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default App;
